// extracted by mini-css-extract-plugin
module.exports = {"container":"video_gallery-module--container--oMRfC","video":"video_gallery-module--video--1BneE"};